export default "__VITE_ASSET__aa331a25__"